<template>
  <el-dialog
    width="800px"
    :visible="show"
    :title="title"
    @close="$emit('update:visible', false)"
  >
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
        height="100%"
        max-height="100%"
        :data="tableData"
        border
        stripe
        style="min-width: 100%"
        row-key="index"
        size="mini"
        ref="table">
        <el-table-column
          fixed
          prop="index"
          label="序号"
          width="50"
          align="center"
        />
        <el-table-column
          prop="name"
          label="名称"
          min-width="160"
          align="center"
        />
        <el-table-column
          prop="type"
          label="类型"
          min-width="160"
          align="center"
          v-slot="{ row }"
        >
          <span>{{ row.type === 'VEHICLE' ? '车辆': '车组' }}</span>
        </el-table-column>
      </el-table>
  </el-dialog>
</template>
<script>
export default {
  props: {
    pathId: {
      type: Number,
      default:null
    },
    visible:{
      type:Boolean,
      default:false
    }
  },

  data() {
    return {
      loading:false,
      tableData: [],
    };
  },
  computed:{
    title(){
      return '已绑定车组车辆';
    },
    show:{
      get(){
        return this.visible;
      },
      set(val){
        this.$emit('update:visible',val);
      }
    }
  },
  watch: {
    show:{
      handler(val){
        this.$nextTick(() => {
          val && this.getData();
        })
      },
      deep:true
    }
  },
  methods: {
    async getData(){
      try{
        const { msg, code, data } = await this.$API.getVehicleBindInfo({ pathId:this.pathId });
        if(code !== 0) throw { msg };
        if(data){
          this.tableData = data.map((item, index) => ({
            ...item,
            index:index+1
          }));
        }else{
          this.tableData = [];
        }
      }catch(err){
        console.log(err);
      }
    },

  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body{
  padding: 10px;
  border-top: 1px solid #EEE;
}
.list{
  display: flex;
  justify-content: space-between;
  height: 400px;
}
</style>
